import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col, Modal, Button, Tab, Tabs, Dropdown, Form } from 'react-bootstrap';
import { faPlus, faXmark, faCircle, faEye, faSpinner, faLocationDot, faCircleCheck, faPaperclip, faChevronDown, faGear, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import Slider from "react-slick";
import TruckWhite from '../../../../assets/images/truck-white.png';
import Docmnt from '../../../../assets/images/google-docs.png';
import Loading from "../../../../assets/images/loading.png";
import Unloading from "../../../../assets/images/Unloading.png";
import Rapdf from "../../../../assets/images/pdf.png";
import Cargoplane from "../../../../assets/images/plane.svg";
import Export from "../../../../assets/images/export.svg";
import edit from "../../../../assets/images/edit.png";
import Cargotruck from "../../../../assets/images/cargo-truck.png";
import Cuser from "../../../../assets/images/cuser.png";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import ImageUpload from '../../../../Components/common/ImageUpload';
import ActivityComments from '../../../../Components/common/ActivityComments';
import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { TRUCKAWBDETAILS, SLOTPLANNINGAVAILABLESLOT, SLOTPLANNINGAVAILABLESLOTCOUNT } from '../../../../Utils/conts.js';
import Select from 'react-select';
import bin from '../../../../assets/images/bin.png';
import Planned from "../../../../assets/images/red_truck.png";
import Schdule from "../../../../assets/images/tracking2.png";
import TripEditModal from './common/TripEditModal.js';
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';
const VehicleView = () => {
    const [rowData, setRowData] = useState();
    const [mode, setMode] = useState();
    const isMounted = useRef(false);
    const [getDestination, setGetDestination] = useState([]);
    const [handlerNames, setHandlerNames] = useState([]);
    const [handlerNamesUnloading, setHandlerNamesUnloading] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [filterApplied, setFilterApplied] = useState(false);
    const [gridData, setGridData] = useState([]);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [gridSelect, setGridSelect] = useState([]);
    const [gridSelectData, setGridSelectData] = useState([]);
    const [orderDetailsModal, setOrderDetailsModal] = useState(false);
    const gridRef = useRef(null);
    const gridRefs = useRef({});
    const [isLoadingod, setIsLoadingOd] = useState(false);
    const [driver2, setDriver2] = useState(false);
    const [activeStep, setActiveStep] = useState(1);
    const [showModalRequestSlot, setShowModalRequestSlot] = useState(false);
    const [tripEditData, setTripEditData] = useState([]);
    const imageUploadRef = useRef(null);
    const [tdFormData, setTdFormData] = useState({
        driver1_first_name: "",
        driver1_last_name: "",
        license_plate: "",
        side_loading: "",
        trip_status: "",
        orderDetails: [
            {
                order_no: '',
                truck_no: '',
                truck_date: ''
            }
        ]
    });
    const [sbFormData, setSbFormData] = useState({
        loading: [],
        unloading: []
    });
    const steps = [
        { id: 1, title: "Trip Details" },
        { id: 2, title: "Slot Booking" }
    ];

    useEffect(() => {
        if (isMounted.current) return;
        // Call the fetchData function to fetch data from the API
        // fetchDataGrid();
        setIsLoading(false);
        setGridData([]);
        fetchDestination();
        isMounted.current = true;
    }, []);

    useEffect(() => {
        if (gridRef.current) {
            // var token = "Bearer " + (localStorage.RFS || localStorage.Trucking || '');
            jqxCookieCall()
            const source = {
                url: `${process.env.REACT_APP_RFS_URL}trip-view-list`,
                // url: `${process.env.REACT_APP_RFS_URL}monitor/vehicle-view-list`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                datatype: 'json',
                id: '',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'vehicle_no', type: 'string' },
                    { name: 'date', type: 'string' },
                    { name: 'triplist', type: 'string' },
                    { name: 'pick_status', type: 'string' },
                    { name: 'orders', type: 'string' },
                    { name: 'shipments_number', type: 'string' },
                    { name: 'driver_name', type: 'string' },
                    { name: 'truck_no', type: 'string' },
                    { name: 'trucker_name', type: 'string' },
                    { name: 'order_type', type: 'string' },
                    { name: 'door_no', type: 'string' },
                    { name: 'trip_no', type: 'string' },
                    { name: 'trip_status', type: 'string' },
                    { name: 'loading', type: 'string' },
                    { name: 'unloading', type: 'string' },
                    { name: 'trip_shippings', type: 'string' },
                    { name: 'status', type: 'string' },
                    { name: 'driver1_first_name', type: 'string' },
                    { name: 'driver1_last_name', type: 'string' },
                    { name: 'driver2_first_name', type: 'string' },
                    { name: 'driver2_last_name', type: 'string' },
                ],
                filter: function (allfilters) {
                    window.$(gridRef.current).jqxGrid('clearselection');
                    setGridSelect([]);
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                    } else {
                        setFilterApplied(false);
                    }
                    window.$(gridRef.current).jqxGrid("updatebounddata", "filter");
                },
                beforeprocessing: function (data) {
                    if (data && data.Rows) {
                        // data.Rows = data.Rows.map(row => ({
                        //     ...row,
                        //     order_no: row.order?.order_no || '',
                        //     truck_no: row.order?.truck_no || '',
                        //     truck_date: row.order?.truck_date || ''
                        // }));
                        source.totalrecords = data.TotalRows;
                    }
                },
                sort: function () {
                    window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            const columns = [
                { text: 'Trip No.', filtertype: 'textbox', datafield: 'trip_no', width: '10%', cellclassname: '', },
                { text: 'Vehicle No.', filtertype: 'textbox', datafield: 'vehicle_no', width: '8%', cellclassname: '', },
                // { text: 'Driver Name', filtertype: 'textbox', datafield: 'driver_name', width: '18%', cellclassname: '', },
                {
                    text: 'Driver Name',filtertype: 'textbox', datafield: 'driver_name', width: '18%', cellclassname: '',
                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {

                        const d1First = data.driver1_first_name || '';
                        const d1Last = data.driver1_last_name || '';
                        const d2First = data.driver2_first_name || '';
                        const d2Last = data.driver2_last_name || '';
                        let driverName = `${d1First} ${d1Last}`.trim();
                        if (d2First) {
                            driverName += ` / ${d2First} ${d2Last}`.trim();
                        }

                        return `<div  class='jqx-grid-cell-left-align' style="margin-top: 13.5px;">${driverName}</div>`;
                    }
                },
                // {
                //     text: 'Trip Edit', datafield: 'status', width: '5%', filterable: false,
                //     cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                //         if (cellValue !== 0) {
                //             return '<div class="jqx-grid-cell-left-align edit_create_trip"><img src="' + Schdule + '"/>  </div>';
                //         } else {
                //             return '<div class="jqx-grid-cell-left-align open_create_trip" style="margin-top:6px;"> <img src="' + Planned + '"/>  </div>';
                //         }
                //     },
                // },
                // { text: 'Trip Status.', filtertype: 'textbox', datafield: 'trip_status', width: '6%', cellclassname: '', },
                {
                    text: 'Triplist', filterable: false, datafield: 'triplist', width: '4%', cellclassname: '',
                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        if (cellValue) {
                            defaultHtml = "<div style='text-align: center;line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
                        }
                        return (
                            defaultHtml
                        );
                    },
                },
                {
                    text: 'Orders',
                    filtertype: 'textbox',
                    datafield: 'orders',
                    width: '5%',
                    cellsrenderer: (row, columnfield, value) => {
                        const count = Array.isArray(value) ? value.length : 0;
                        return `<div class="jqx-grid-cell-left-align" style="margin-top: 13.5px;">${count}</div>`;
                    }
                },
                {
                    text: 'Pickup Status', datafield: 'pick_status', width: '12%', filtertype: 'textbox',
                    cellsrenderer: (row, columnfield, value, defaulthtml, columnproperties) => {
                        if (value && Array.isArray(value)) {
                            const content = value
                                .map((item) =>
                                    `<div class="${item.color_status || ''}">${item.status || ''}</div>`
                                ).join('');

                            return `<div class="stats_view">${content}</div>`;
                        }
                        return defaulthtml;
                    }
                },
                {
                    text: 'Loading',
                    datafield: 'loading',
                    width: '15%',
                    cellsrenderer: (row, columnfield, value, defaulthtml, column, data) => {
                        if (!Array.isArray(data.trip_shippings)) return '';
                        const stations = [
                            ...new Set(
                                data.trip_shippings
                                    .filter(item => item.shipping_type === 'L')
                                    .map(item => item.station)
                            )
                        ].join(', ');

                        return `<div class="jqx-grid-cell-left-align" style="margin-top: 13.5px;">${stations}</div>`;
                    }
                },
                {
                    text: 'Unloading',
                    datafield: 'unloading',
                    width: '15%',
                    cellsrenderer: (row, columnfield, value, defaulthtml, column, data) => {
                        if (!Array.isArray(data.trip_shippings)) return '';
                        const stations = [
                            ...new Set(
                                data.trip_shippings
                                    .filter(item => item.shipping_type === 'U')
                                    .map(item => item.station)
                            )
                        ].join(', ');

                        return `<div class="jqx-grid-cell-left-align" style="margin-top: 13.5px;">${stations}</div>`;
                    }
                },
            ];
            const torColumns = [
                { text: 'Order No.', datafield: 'order_no', width: '9%' },
                { text: 'Truck No.', datafield: 'truck_no', width: '7%' },
                { text: 'Truck Date', datafield: 'truck_date', width: '7%', cellsformat: 'dd-MM-yyyy', filtertype: 'date', },
                {
                    text: 'Pickup Status', datafield: 'pick_status', width: '11%',
                    cellsrenderer: (row, columnfield, value, defaulthtml, columnproperties) => {
                        if (value && Array.isArray(value)) {
                            const content = value
                                .map((item) =>
                                    `<div class="${item.color_status || ''}">${item.status || ''}</div>`
                                ).join('');
                            return `<div class="stats_view">${content}</div>`;
                        }
                        return defaulthtml;
                    }
                },
                {
                    text: 'Loading Advice', datafield: 'loading_advice', width: '6%',
                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        if (cellValue) {
                            defaultHtml = "<div style='text-align: center;line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
                        }
                        return (
                            defaultHtml
                        );
                    },
                },
                { text: 'Carrier Name', datafield: 'carrier_name', width: '9%' },
                { text: 'Loading Date', cellsformat: 'dd-MM-yyyy', datafield: 'loading_date_planned', width: '9%' },
                { text: 'Loading Station', datafield: 'loading_station', width: '6%' },
                { text: 'Loading Location', datafield: 'loading_name', width: '9%' },
                { text: 'Unloading Date', cellsformat: 'dd-MM-yyyy', datafield: 'unloading_date_planned', width: '9%' },
                { text: 'Unloading Station', datafield: 'unloading_station', width: '7%' },
                { text: 'Unloading Location', datafield: 'unloading_name', width: '10%' },
            ];
            const torGrids = {};
            const torrowdetails = (index, parentElement, gridElement, record) => {
                const torGridContainer = parentElement.children[0];
                const parentRowId = record.uid.toString();
                torGrids[parentRowId] = torGridContainer;
                parentElement.addEventListener('click', (event) => {
                    const target = event.target;
                    if (window.$(target).hasClass('jqx-icon-arrow-right')) {
                        event.stopPropagation();
                    }
                });
                const id = record.uid.toString();
                const uldGrid = dataAdapter.loadedData.Rows[id]?.orders;
                const torSource = {
                    datatype: 'json',
                    id: 'shipmentChildID',
                    datafields: [
                        { name: 'id', type: 'string' },
                        { name: 'order_id', type: 'string' },
                        { name: 'order_no', type: 'string' },
                        { name: 'truck_no', type: 'string' },
                        { name: 'pick_status', type: 'string' },
                        { name: 'loading_advice', type: 'string' },
                        { name: 'carrier_name', type: 'string' },
                        { name: 'trucker_name', type: 'string' },
                        { name: 'flight_number', type: 'string' },
                        { name: 'loading_station', type: 'string' },
                        { name: 'loading_name', type: 'string' },
                        { name: 'loading_location', type: 'string' },
                        { name: 'unloading_station', type: 'string' },
                        { name: 'unloading_name', type: 'string' },
                        { name: 'unloading_location', type: 'string' },
                        { name: 'loading_date_planned', type: 'date' },
                        { name: 'unloading_date_planned', type: 'date' },
                        { name: 'truck_date', type: 'date' },
                    ],
                    localdata: uldGrid,
                }
                const torDataAdapter = new window.$.jqx.dataAdapter(torSource);
                const awbColumns = [
                    { text: 'Airway Bill', datafield: 'airway_bill', width: '8%' },
                    {
                        text: 'Pickup Status', datafield: 'pick_status', width: '10%',
                        cellsrenderer: (row, columnfield, value, defaulthtml, columnproperties) => {
                            if (value && Array.isArray(value)) {
                                const content = value
                                    .map((item) =>
                                        `<div class="${item.color_status || ''}">${item.status || ''}</div>`
                                    ).join('');

                                return `<div class="stats_view">${content}</div>`;
                            }
                            return defaulthtml;
                        }
                    },
                    { text: 'Pcs', datafield: 'pieces', width: '5%' },
                    { text: 'RCF', datafield: 'rcf', width: '5%' },
                    { text: 'MAN', datafield: 'man', width: '5%' },
                    { text: 'MSCA', datafield: 'msca', width: '5%' },
                    { text: 'Package', datafield: 'package', width: '8%' },
                    { text: 'ULD No.', datafield: 'uld_number', width: '8%' },
                    { text: 'Weight', datafield: 'weight', width: '8%' },
                    { text: 'Volume', datafield: 'volume', width: '8%' },
                    { text: 'LM', datafield: 'lm', width: '8%' },
                    { text: 'Nature of Goods', datafield: 'nature_of_goods', width: '8%' },
                ];
                const awbGrids = {};
                const awbrowdetails = (index, parentElement, gridElement, record) => {
                    const awbGridContainer = parentElement.children[0];
                    const parentRowId = record.uid.toString();
                    awbGrids[parentRowId] = awbGridContainer;
                    parentElement.addEventListener('click', (event) => {
                        const target = event.target;
                        if (window.$(target).hasClass('jqx-icon-arrow-right')) {
                            event.stopPropagation();
                        }
                    });
                    const id = record.uid.toString();
                    const uldGrid = torDataAdapter.loadedData[id]?.order_awbs;
                    const awbSource = {
                        datatype: 'json',
                        id: 'shipmentChildID',
                        datafields: [
                            { name: 'id', type: 'string' },
                            { name: 'airway_bill', type: 'string' },
                            { name: 'pick_status', type: 'string' },
                            { name: 'pieces', type: 'string' },
                            { name: 'rcf', type: 'string' },
                            { name: 'man', type: 'string' },
                            { name: 'msca', type: 'string' },
                            { name: 'package', type: 'string' },
                            { name: 'uld_number', type: 'string' },
                            { name: 'weight', type: 'string' },
                            { name: 'volume', type: 'string' },
                            { name: 'lm', type: 'string' },
                            { name: 'nature_of_goods', type: 'string' },
                        ],
                        localdata: uldGrid,
                    }
                    const awbDataAdapter = new window.$.jqx.dataAdapter(awbSource);
                    const awbGridOptions = {
                        width: '100%',
                        pageable: false,
                        sortable: false,
                        // pageSize: 15,
                        autoheight: false,
                        height: (10 * 45),
                        selectionmode: '',
                        source: awbDataAdapter,
                        filterable: false,
                        columns: awbColumns,
                        rowdetails: true,
                        rowsheight: 45,
                        showemptyrow: false,
                        ready: function () {
                            const rows = window.$(awbGridContainer).jqxGrid('getrows');
                            for (let i = 0; i < rows.length; i++) {
                                const rowid = i; // Use index as the new row ID
                                const row = rows[i];
                                window.$(awbGridContainer).jqxGrid('setcellvalue', row.uid, 'uid', rowid);
                                window.$(awbGridContainer).jqxGrid('updaterow', rowid, row);
                                window.$(awbGridContainer).find(`[role="row"][row-id="${row.uid}"]`).attr('row-id', rowid);
                            }
                        },
                    };
                    window.$(awbGridContainer).jqxGrid(awbGridOptions);
                };
                const torGridOptions = {
                    width: '100%',
                    pageable: false,
                    sortable: false,
                    // pageSize: 15,
                    autoheight: false,
                    height: (10 * 45),
                    selectionmode: '',
                    source: torDataAdapter,
                    filterable: false,
                    columns: torColumns,
                    rowdetails: true,
                    rowsheight: 45,
                    showemptyrow: false,
                    initrowdetails: awbrowdetails,
                    rowdetails: true,
                    rowdetailstemplate: {
                        rowdetails: '<div id="awbGrid" style="margin: 10px;"></div>',
                        rowdetailsheight: (10 * 45),
                        rowdetailshidden: true,
                    },
                    ready: function () {
                        const rows = window.$(torGridContainer).jqxGrid('getrows');
                        for (let i = 0; i < rows.length; i++) {
                            const rowid = i; // Use index as the new row ID
                            const row = rows[i];
                            window.$(torGridContainer).jqxGrid('setcellvalue', row.uid, 'uid', rowid);
                            window.$(torGridContainer).jqxGrid('updaterow', rowid, row);
                            window.$(torGridContainer).find(`[role="row"][row-id="${row.uid}"]`).attr('row-id', rowid);
                        }
                    },
                };
                window.$(torGridContainer).jqxGrid(torGridOptions);
            };
            const gridOptions = {
                width: "100%",
                source: dataAdapter,
                columns: columns,
                selectionmode: '',
                autoheight: true,
                virtualmode: true,
                sortable: true,
                altrows: false,
                enabletooltips: true,
                editable: false,
                initrowdetails: torrowdetails,
                pageable: true,
                pageSize: 20,
                pagesizeoptions: ["20", "50", "100", "200", "500"],
                pagerButtonsCount: 5,
                pagerMode: "advanced",
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                selectionmode: 'checkbox',
                rowdetails: true,
                rowdetailstemplate: {
                    rowdetails: '<div id="nestedGrid" style="margin: 10px;"></div>',
                    rowdetailsheight: 10 * 45,
                    rowdetailshidden: true,
                },
                rendergridrows: function (params) {
                    return params.data;
                },
            };
            window.$(gridRef.current).jqxGrid(gridOptions);
            window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');
            window.$(gridRef.current).on('click', '.open_create_trip', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const boundIndex = window.$(gridRef.current).jqxGrid('getrowid', rowIndex);
                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRef.current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                    const rowData = window.$(gridRef.current).jqxGrid('getrowdata', globalIndex);
                    if (rowData) {
                        console.log('Row Data:', rowData);
                        // getTripData(rowData.id);
                        setRowData(rowData);
                        setMode('edit');
                    } else {
                        console.error('No data found for the given row index.');
                    }
                } else {
                    console.error('Bound index could not be retrieved. Check the row index and data binding.');
                }
            });
            window.$(gridRef.current).on('click', '.edit_create_trip', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const boundIndex = window.$(gridRef.current).jqxGrid('getrowid', rowIndex);
                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRef.current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                    const rowData = window.$(gridRef.current).jqxGrid('getrowdata', globalIndex);
                    if (rowData) {
                        const updatedRowData = {
                            ...rowData,
                            typeOf: 'edit'
                        };
                        setRowData(updatedRowData);
                        setMode('edit');
                    } else {
                        console.error('No data found for the given row index.');
                    }
                } else {
                    console.error('Bound index could not be retrieved. Check the row index and data binding.');
                }
            });
            window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRef.current).off('cellclick');
            window.$(gridRef.current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                if (![0, 3].includes(event.args.columnindex)) {
                    if (gridSelect) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                    }
                }
            });
        }
    }, [gridData]);

    useEffect(() => {
        if (showModalRequestSlot == true) return;
        setActiveStep(1);
        setGridSelectData([]);
        setTripEditData([]);
        setTdFormData({
            driver1_first_name: "",
            driver1_last_name: "",
            license_plate: "",
            side_loading: "",
            trip_status: "",
            orderDetails: [
                {
                    order_no: '',
                    truck_no: '',
                    truck_date: ''
                }
            ]
        });
        setSbFormData({
            loading: [],
            unloading: []
        });
    }, [showModalRequestSlot]);

    useEffect(() => {
        if (sbFormData.loading.station) {
            fetchHandler(sbFormData.loading.station, "loading");
        }
    }, [sbFormData.loading.station])

    useEffect(() => {
        if (sbFormData.unloading.station) {
            fetchHandler(sbFormData.unloading.station, "unloading");
        }
    }, [sbFormData.unloading.station]);

    useEffect(() => {
        if (sbFormData.loading.warehouse_id && sbFormData.loading.date) {
            availableSlot(sbFormData.loading.date, sbFormData.loading.warehouse_id, 'loading');
        }
    }, [sbFormData.loading.date]);

    useEffect(() => {
        if (sbFormData.unloading.warehouse_id && sbFormData.unloading.date) {
            availableSlot(sbFormData.unloading.date, sbFormData.unloading.warehouse_id, 'unloading');
        }
    }, [sbFormData.unloading.date]);

    useEffect(() => {
        console.log(sbFormData)
    }, [sbFormData]);
    useEffect(() => {
        console.log(tdFormData)
    }, [tdFormData]);

    const getTripData = async (id) => {
        try {
            const res = await withRFSToken.post('trip-details', { trip_id: id })
                .then(function (res) {
                    setTripEditData(res.data);
                    setActiveStep(1);
                    const data = res.data;
                    setGridSelectData(data.orders);
                    if (data.trip_details.driver2_first_name) {
                        setDriver2(true);
                    } else {
                        setDriver2(false);
                    }
                    setTdFormData({
                        driver1_first_name: data.trip_details.driver1_first_name ?? "",
                        driver1_last_name: data.trip_details.driver1_last_name ?? "",
                        driver2_first_name: data.trip_details.driver2_first_name ?? "",
                        driver2_last_name: data.trip_details.driver2_last_name ?? "",
                        truck_license_plate: data.trip_details.truck_license_plate ?? "",
                        trailer_license_plate: data.trip_details.trailer_license_plate ?? "",
                        side_loading: data.trip_details.side_loading ?? "",
                        trip_status: data.trip_details.trip_status ?? "",
                        orderDetails: (data.order_ids || []).map(orderId => ({
                            order_no: orderId,
                            truck_no: "",
                            truck_date: ""
                        }))
                    });
                    const loading = [];
                    const unloading = [];
                    (data.slot_booking || []).forEach(item => {
                        const truckNos = item.order_shippings?.map(item => item.order?.truck_no).filter(Boolean).join(", ");
                        const slotItem = {
                            station: item.station,
                            station_id: item.station_id,
                            handler_org_id: item.handler_org_id,
                            handler_name: item.handler_name,
                            warehouse_id: item.warehouse_id,
                            slots: item.slots[0],
                            id: item.id,
                            date: item.planned_date_time
                                ? item.planned_date_time.replace(" ", "T")
                                : null,
                            availableSlots: {
                                past: [],
                                present: null,
                                future: [],
                                message: ""
                            },
                            truckNos: truckNos
                        };
                        if (item.shipping_type === "L") {
                            loading.push(slotItem);
                        }
                        if (item.shipping_type === "U") {
                            unloading.push(slotItem);
                        }
                    });
                    setSbFormData({
                        loading,
                        unloading
                    });
                    syncGridSelection();
                    setShowModalRequestSlot(true);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const validateTdStep = (fields) => {
        for (const field of fields) {
            if (!tdFormData[field] || tdFormData[field].toString().trim() === '') {
                return false;
            }
        }

        return true;
    };

    const handleCloseClick = () => {
        setSelectedRowData(null);
    };

    const movementHistoryClick = () => {
        localStorage.removeItem('MHistory');
        const storageData = {
            ULD: selectedRowData,  // ULD Details section
            Form: {}  // Empty form section
        };
        localStorage.setItem('MHistory', JSON.stringify(storageData));
        // localStorage.setItem('tab', 'operations');
        window.location.href = '/ULDControl/MovementHistory'
    };

    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };

    const handleRequestSlot = () => {
        setMode('create')
    }

    const goNext = () => {
        if (!validateTdStep([
            'driver1_first_name',
            'driver1_last_name',
            'side_loading',
            'trip_status',
            'trailer_license_plate',
            'truck_license_plate'
        ])) {
            toast.error('Please fill all mandatory fields before proceeding.')
            return;
        }

        if (activeStep < steps.length) setActiveStep(activeStep + 1);
    };

    const handleSubmit = async () => {
        const order_ids = (gridSelectData || []).map(o => o.id);
        const slot_booking = [
            ...(sbFormData.loading || []).map(item => {
                const d = new Date(item.date);
                const station_id = getDestination.find(station => station.label === item.station)?.port_Id || null;
                return {
                    shipping_type: "L",
                    station: item.station,
                    station_id: station_id,
                    handler_org_id: item.handler_org_id,
                    handler_name: item.handler_name,
                    planned_date_time: item.date,
                    date: d.toISOString().split("T")[0],
                    time: d.toTimeString().slice(0, 8),
                    warehouse_id: item.warehouse_id,
                    id: item.id ?? null,
                    slot: item.slot || null
                };
            }),
            ...(sbFormData.unloading || []).map(item => {
                const d = new Date(item.date);
                const station_id = getDestination.find(station => station.label === item.station)?.port_Id || null;
                return {
                    shipping_type: "U",
                    station: item.station,
                    station_id: station_id,
                    handler_org_id: item.handler_org_id,
                    handler_name: item.handler_name,
                    planned_date_time: item.date,
                    date: d.toISOString().split("T")[0],
                    time: d.toTimeString().slice(0, 8),
                    warehouse_id: item.warehouse_id,
                    id: item.id ?? null,
                    slot: item.slot || null
                };
            })
        ];
        const payload = {
            trip_details: {
                trip_status: tdFormData.trip_status,
                vehicle_type: "Truck",
                side_loading: tdFormData.side_loading,
                truck_license_plate: tdFormData.truck_license_plate,
                trailer_license_plate: tdFormData.trailer_license_plate ?? "",
                driver1_first_name: tdFormData.driver1_first_name,
                driver1_last_name: tdFormData.driver1_last_name,
                driver2_first_name: tdFormData.driver2_first_name ?? "",
                driver2_last_name: tdFormData.driver2_last_name ?? ""
            },
            order_ids,
            slot_booking,
            trip_id: tripEditData.trip_id ?? null
        };
        try {
            const res = await withRFSToken.post('trip-management/save-trip', payload)
                .then(function (res) {
                    if (res.data.response_code === 200) {
                        setShowModalRequestSlot(false);
                        toast.success(res.data.response_msg);
                    } else {
                        toast.error(res.data.response_msg);
                    }
                    refreshGrid();
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const goPrevious = () => {
        if (activeStep > 1) setActiveStep(activeStep - 1);
    };

    const handleChange = (form, event) => {
        const { name, value } = event.target;
        if (form === "td") {
            setTdFormData(prev => ({ ...prev, [name]: value }));
        }
        if (form === "sb") {
            setSbFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const fetchDestination = async () => {
        try {
            const res = await withRFSToken.post('trip-management/get-station-with-warehouses', {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData.map(item => ({
                        value: item.port_Id,
                        label: item.code,
                        port_Id: item.port_Id,
                        station_users: item.station_users
                    }));
                    setGetDestination(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const fetchHandler = async (stationCode, type) => {
        try {
            const res = await withRFSToken.post('uld-from/get-forwarder-handler', { station_code: stationCode });
            const innerData = res.data.response_data;
            if (type === "loading") {
                setHandlerNames(innerData);
            } else if (type === "unloading") {
                setHandlerNamesUnloading(innerData);
            }
        } catch (error) {
            console.error('Error fetching handler data:', error);
            return [];
        }
    }

    const formatTime = (datetime) => {
        return new Date(datetime).toLocaleTimeString('en-IN', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        });
    };

    const formatDate = (datetime) => {
        return new Date(datetime).toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short', // e.g., Sep
        });
    };

    const handleSlotClick = (type, index, slotType, slot, setSbFormData) => {
        setSbFormData(prev => {
            const updated = [...prev[type]];
            updated[index] = {
                ...updated[index],
                selected_slot_type: slotType,
                selected_slot_key: `${slot.door_id}_${slot.start_time}`,
                slot: slot,
            };
            return {
                ...prev,
                [type]: updated
            };
        });
    };

    const availableSlot = async (date, warehouseId, type, index, setSbFormData) => {
        if (!date || !warehouseId) return;
        try {
            const [dateVal, timeVal] = date.split("T");
            const res = await withRFSToken.post(SLOTPLANNINGAVAILABLESLOT, {
                warehouse_id: warehouseId,
                date: dateVal,
                time: timeVal,
                cargo_type_id: tdFormData.side_loading === 'Loose' ? 1 : 2,
                trip_type_id: tdFormData.trip_status === 'Import' ? 4 : 5,
            });
            setSbFormData(prev => {
                const updated = [...prev[type]];
                if (res.data.response_code === 200) {
                    const {
                        recentBefore = [],
                        recentSlots = null,
                        upcomingAfter = []
                    } = res.data.response_data || {};
                    updated[index] = {
                        ...updated[index],
                        availableSlots: {
                            past: recentBefore,
                            present: recentSlots,
                            future: upcomingAfter,
                            message: ""
                        }
                    };
                } else {
                    updated[index] = {
                        ...updated[index],
                        availableSlots: {
                            past: [],
                            present: null,
                            future: [],
                            message: res.data.response_msg,
                            code: res.data.response_code
                        }
                    };
                }
                return { ...prev, [type]: updated };
            });

        } catch (err) {
            console.error("Available slot fetch failed", err);
        }
    };

    const loadGrid = () => {
        if (gridRefs.current) {
            // const token = 'Bearer ' + localStorage.Trucking;
            jqxCookieCall()
            const source = {
                datatype: 'json',
                url: `${process.env.REACT_APP_RFS_URL}order-view-list`,
                root: 'Rows',
                cache: false,
                datafields: [
                    { name: 'id', type: 'number' },
                    { name: 'order_no', type: 'string' },
                    { name: 'truck_no', type: 'string' },
                    { name: 'truck_date', type: 'string' }
                ],
                // beforeSend: (jqXHR) => {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                filter: function (allfilters) {
                    window.$(gridRefs.current).jqxGrid('clearselection');
                    window.$(gridRefs.current).jqxGrid("updatebounddata", "filter");
                },
                beforeprocessing: function (data) {
                    if (data && data.Rows) {
                        // data.Rows = data.Rows.map(row => ({
                        //     ...row,
                        //     order_no: row.order?.order_no || '',
                        //     truck_no: row.order?.truck_no || '',
                        //     truck_date: row.order?.truck_date || ''
                        // }));
                        source.totalrecords = data.TotalRows;
                    }
                }
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            const columns = [
                { text: 'Order No', datafield: 'order_no', width: '33%' },
                { text: 'Truck No', datafield: 'truck_no', width: '33%' },
                {
                    text: 'Truck Date',
                    datafield: 'truck_date',
                    width: '33%',
                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        if (!cellValue) return '';
                        const formattedDate = new Date(cellValue).toISOString().split('T')[0];
                        return `<div style="margin-top:8px;">${formattedDate}</div>`;
                    }
                }
            ];
            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 800,
                sortable: true,
                altrows: false,
                enabletooltips: true,
                editable: false,
                pagesizeoptions: ['20', '100', '200', '500'],
                pageable: true,
                pageSize: 20,
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                selectionmode: 'checkbox',
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
            };

            window.$(gridRefs.current).jqxGrid(gridOptions);
            window.$(gridRefs.current).on('rowselect', function (event) {
                const rowIndex = event.args.rowindex;
                const rowData = window.$(gridRefs.current).jqxGrid('getrowdata', rowIndex);

                setGridSelectData(prev => {
                    // Prevent duplicate entry
                    if (prev.some(row => row.id === rowData.id)) {
                        return prev;
                    }
                    return [...prev, rowData];
                });
            });
            window.$(gridRefs.current).on('rowunselect', function (event) {
                const rowIndex = event.args.rowindex;
                const rowData = window.$(gridRefs.current).jqxGrid('getrowdata', rowIndex);

                setGridSelectData(prev =>
                    prev.filter(row => row.id !== rowData.id)
                );
            });
            window.$(gridRefs.current).on('bindingcomplete', function () {
                syncGridSelection();
            });
        }
    };

    const syncGridSelection = () => {
        if (!gridRefs.current || !gridSelectData.length) return;
        const rows = window.$(gridRefs.current).jqxGrid('getrows');
        gridSelectData.forEach(selected => {
            const rowIndex = rows.findIndex(r => r.id === selected.id);
            if (rowIndex !== -1) {
                window.$(gridRefs.current).jqxGrid('selectrow', rowIndex);
            }
        });
    };

    const uncheckGridRowById = (id) => {
        const rows = window.$(gridRefs.current).jqxGrid('getrows');
        const rowIndex = rows.findIndex(r => r.id === id);
        if (rowIndex !== -1) {
            window.$(gridRefs.current).jqxGrid('unselectrow', rowIndex);
        }
    };

    const handleAddorder = async () => {
        try {
            const res = await withRFSToken.post("trip-management/get-order-shippings", { order_ids: gridSelectData.map(item => item.id) })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const loadingArr = [];
                    const unloadingArr = [];

                    innerData.forEach(item => {
                        const truckNos = item.truck_nos.join(", ");;
                        const baseObj = {
                            station: item.station,
                            handler_org_id: item.handler_org_id,
                            handler_name: item.handler_name,
                            warehouse_id: null,
                            date: item.planned_date_time,
                            availableSlots: {
                                past: [],
                                present: null,
                                future: []
                            },
                            truckNos: truckNos
                        };

                        if (item.shipping_type === "L") {
                            loadingArr.push(baseObj);
                        }

                        if (item.shipping_type === "U") {
                            unloadingArr.push(baseObj);
                        }
                    });

                    setSbFormData({
                        loading: loadingArr,
                        unloading: unloadingArr
                    });
                    setOrderDetailsModal(false);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const getHandlersByStation = (stationCode, handlerOrgId) => {
        const station = getDestination.find(s => s.label === stationCode);
        if (!station || !station.station_users) return [];

        // return station.station_users.flatMap(user =>
        //     (user.warehouses || []).map(warehouse => ({
        //         value: warehouse.id,
        //         label: `${warehouse.name}`,
        //         org_id: user.org_id,
        //         warehouse_id: warehouse.id,
        //         station_user_id: user.id
        //     }))
        // );
        return station.station_users
            .filter(user => user.org_id === handlerOrgId)
            .flatMap(user =>
                (user.warehouses || []).map(warehouse => ({
                    value: warehouse.id,
                    label: warehouse.name,
                    org_id: user.org_id,
                    warehouse_id: warehouse.id,
                    station_user_id: user.id
                }))
            );
    };

    const isSelectedSlot = (item, slotType, slot) => {
        if (!item.selected_slot_key) return false;

        const slotKey = `${slot.door_id}_${slot.start_time}`;

        return (
            item.selected_slot_type === slotType &&
            item.selected_slot_key === slotKey
        );
    };

    const refreshGrid = () => {
        const grid = window.$(gridRef.current);
        grid.jqxGrid('updatebounddata');
        grid.jqxGrid('refresh');
        setMode(null);
        setRowData(null);
    };

    const handleStepClick = (stepId) => {
        if (stepId == 2) {
            if (!validateTdStep([
                'driver1_first_name',
                'driver1_last_name',
                'side_loading',
                'trip_status',
                'trailer_license_plate',
                'truck_license_plate'
            ])) {
                toast.error('Please fill all mandatory fields before proceeding.')
                return;
            }
        }
        setActiveStep(stepId);
    };

    const StationLoop = ({ type, data, setSbFormData }) => {
        useEffect(() => {
            data.forEach((item, index) => {
                const hasValidInputs =
                    item.date &&
                    item.warehouse_id &&
                    item.handler_org_id;

                const slotsNotLoaded =
                    !item.availableSlots ||
                    (
                        item.availableSlots.past?.length === 0 &&
                        !item.availableSlots.present &&
                        item.availableSlots.future?.length === 0 &&
                        !item.availableSlots.message
                    );

                if (hasValidInputs && slotsNotLoaded) {
                    availableSlot(
                        item.date,
                        item.warehouse_id,
                        type,
                        index,
                        setSbFormData
                    );
                }
            });
        }, [data, type, setSbFormData]);
        return (
            <>
                {data.map((item, index) => {
                    const slots = item.availableSlots || {
                        past: [],
                        present: null,
                        future: [],
                        message: ""
                    };
                    const handlerOptions = getHandlersByStation(item.station, item.handler_org_id);
                    return (
                        <div className={`${type}Loop Loop`} key={`${type}-${index}`}>
                            <div className='truck_no'>
                                <h4>Truck No : {item.truckNos} </h4>
                                {/* <p></p> */}
                            </div>
                            <div className="rounded charter_top charter_from">
                                <Form.Group as={Row} className="mb-1">
                                    <Col sm="6">
                                        {item.handler_org_id ? (
                                            <>
                                                <label className="form-label">
                                                    Station Code <span>*</span>
                                                </label>
                                                <Select classNamePrefix="rs"
                                                    options={getDestination}
                                                    value={getDestination.find(o => o.label === item.station)}
                                                    onChange={(selected) => {
                                                        setSbFormData(prev => {
                                                            const updated = [...prev[type]];
                                                            updated[index] = {
                                                                ...updated[index],
                                                                station: selected.label,
                                                                station_id: selected.port_Id,
                                                                handler_org_id: null,
                                                                handler_name: "",
                                                                warehouse_id: null,
                                                                availableSlots: {
                                                                    past: [],
                                                                    present: null,
                                                                    future: [],
                                                                    message: ""
                                                                }
                                                            };
                                                            return { ...prev, [type]: updated };
                                                        });
                                                    }}
                                                    isDisabled="true"
                                                />
                                            </>
                                        ) : (
                                            <>
                                                <label className="form-label">Station Code</label>
                                                <div className="form-control bg-light">
                                                    {item.station || "—"}
                                                </div>
                                            </>
                                        )}

                                    </Col>
                                    <Col sm="6">
                                        {item.handler_org_id ? (
                                            handlerOptions.length > 0 ? (
                                                <>
                                                    <label className="form-label">
                                                        Handler Name <span>*</span>
                                                    </label>

                                                    <Select
                                                        classNamePrefix="rs"
                                                        options={handlerOptions}
                                                        value={handlerOptions.find(
                                                            o => o.value === item.warehouse_id
                                                        )}
                                                        onChange={(selected) => {
                                                            setSbFormData(prev => {
                                                                const updated = [...prev[type]];

                                                                updated[index] = {
                                                                    ...updated[index],
                                                                    warehouse_id: selected.warehouse_id
                                                                };

                                                                if (updated[index].date) {
                                                                    availableSlot(
                                                                        updated[index].date,
                                                                        selected.warehouse_id,
                                                                        type,
                                                                        index,
                                                                        setSbFormData
                                                                    );
                                                                }

                                                                return { ...prev, [type]: updated };
                                                            });
                                                        }}
                                                    />
                                                </>
                                            ) : (
                                                <>
                                                    <label className="form-label">Handler Name</label>
                                                    <div className="form-control bg-light">
                                                        {item.handler_name || "—"}
                                                        <p className='text-danger'>Door planning not applied, arrival reference only.</p>
                                                    </div>
                                                </>
                                            )
                                        ) : (
                                            <>
                                                <label className="form-label">Handler Name</label>
                                                <div className="form-control bg-light">
                                                    {item.handler_name || "—"}
                                                    <p className='text-danger'>Door planning not applied, arrival reference only.</p>
                                                </div>
                                            </>
                                        )}
                                    </Col>
                                </Form.Group>
                            </div>
                            <div className="rounded charter_top h-90 px-1 bookig_slot">
                                <div className="calendar-container">
                                    <Form.Group as={Row} className="mb-1">
                                        <Col sm="12">
                                            <label className='form-label'>Planned Date / Time</label>
                                            <input
                                                type="datetime-local"
                                                className="form-control"
                                                value={item.date || ""}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setSbFormData(prev => {
                                                        const updated = [...prev[type]];
                                                        const warehouseId = updated[index].warehouse_id;
                                                        updated[index] = {
                                                            ...updated[index],
                                                            date: value
                                                        };
                                                        if (warehouseId) {
                                                            availableSlot(
                                                                value,
                                                                warehouseId,
                                                                type,
                                                                index,
                                                                setSbFormData
                                                            );
                                                        }
                                                        return { ...prev, [type]: updated };
                                                    });
                                                }}
                                            />
                                        </Col>
                                    </Form.Group>
                                    {slots.message && (
                                        <p
                                            className={
                                                slots.code === 400
                                                    ? 'text-danger'
                                                    : slots.code === 405
                                                        ? 'text-inactive'
                                                        : ''
                                            }
                                        >
                                            {slots.message}
                                        </p>
                                    )}
                                    {item.handler_org_id ? (
                                        handlerOptions.length > 0 ? (
                                            <></>
                                        ) : (
                                            <>
                                                <p className='text-inactive'>Door planning not applied, arrival reference only.</p>
                                            </>
                                        )
                                    ) : (
                                        <>
                                            <p className='text-inactive'>Door planning not applied, arrival reference only.</p>
                                        </>
                                    )}
                                    {item?.slots && (
                                        <div className="timeslot previous">
                                            <div className="available time available_time_selected">
                                                {/* <h4>Door No.: {item?.slots?.door_details.door_no}</h4> */}

                                                <span>{item?.slots?.start_time}</span>
                                                <span>{item?.slots?.end_time}</span>
                                            </div>
                                        </div>
                                    )}
                                    {!slots.present?.door_id &&
                                        (slots.past.length > 0 || slots.future.length > 0) && (
                                            <p className="text-danger">
                                                No timeslot available at the selected time. Please select an open option below.
                                            </p>
                                        )}

                                    {slots.present?.door_id && (
                                        <>
                                            <h4 className='avl_time' onClick={() =>
                                                handleSlotClick(
                                                    type,
                                                    index,
                                                    'present',
                                                    slots.present,
                                                    setSbFormData
                                                )
                                            }>Timeslot Available {' '}
                                                <span>
                                                    {formatTime(slots.present.start_time)} {" "} - {" "}
                                                    {formatTime(slots.present.end_time)}
                                                </span>
                                            </h4>
                                        </>
                                    )}
                                    {!slots.present?.door_id && (
                                        <>
                                            {slots.past.length > 0 && (
                                                <div className="avalable">
                                                    <h2>Earlier Timeslot</h2>
                                                    <div className="timeslot">
                                                        {slots.past.map((slot, i) => (
                                                            <div key={i} className={`available time ${isSelectedSlot(item, 'past', slot) ? 'available_tym' : ''}`} onClick={() =>
                                                                handleSlotClick(
                                                                    type,
                                                                    index,
                                                                    'past',
                                                                    slot,
                                                                    setSbFormData
                                                                )
                                                            }>
                                                                {/* <h4>Door No.: {slot.door_no}</h4> */}
                                                                {/* <p>{formatDate(slot.start_time)}</p> */}
                                                                <p>
                                                                    {slot.start_time}  - {slot.end_time}
                                                                </p>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                            {slots.future.length > 0 && (
                                                <div className="avalable">
                                                    <h2>Later Timeslot</h2>
                                                    <div className="timeslot">
                                                        {slots.future.map((slot, i) => (
                                                            <div key={i} className={`available time  ${isSelectedSlot(item, 'future', slot) ? 'available_tym' : ''}`} onClick={() =>
                                                                handleSlotClick(
                                                                    type,
                                                                    index,
                                                                    'future',
                                                                    slot,
                                                                    setSbFormData
                                                                )
                                                            }>
                                                                {/* <h4>Door No.: {slot.door_no}</h4> */}
                                                                {/* <p>{formatDate(slot.start_time)}</p> */}
                                                                <p>
                                                                    {slot.start_time}  -  {slot.end_time}
                                                                </p>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </>
        );
    };

    return (
        <>
            <div className="mb-3 nestedtabs rounded minh">
                <div className='d-flex'>
                    {/* <button className={'exportbtn me-3 active'} onClick={() => handleRequestSlot()}>
                        <img src={TruckWhite} /> <span>Create Trip</span>
                    </button> */}
                </div>
            </div>
            <div className="maindiv">
                <div className='trashdonload'>
                    {!isLoading && <div ref={gridRef} className='bookinggrid' ></div>}
                </div>
                {selectedRowData && (
                    <div className='SecondDiv'>
                        <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
                        <div className='girddtals_header'>
                            <h3>
                                {selectedRowData.uld_number} &nbsp; <span>{selectedRowData.status}</span>
                            </h3>
                            <div className='d-flex actbtn'>

                                <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                                {/* <Dropdown>
                                    <Dropdown.Toggle variant="light" id="dropdown-basic" >
                                        <FontAwesomeIcon icon={faBolt} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item >option</Dropdown.Item>
                                        <Dropdown.Item >option</Dropdown.Item>
                                        <Dropdown.Item >option</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown> */}

                            </div>

                        </div>
                        <div className='movment_history my-2'>
                            <h3>Movement Vehicle</h3> <Link to='#'>View All</Link>
                        </div>
                        <div className='mb-3'>
                            <div className='onging_vehicle mb-2'>
                                <div className='rcf_location'><FontAwesomeIcon icon={faLocationDot} /></div>
                                <div className='d-flex justify-content-between borderh align-items-center'>
                                    <div>
                                        <h3>DNATA - AMS</h3>
                                        <p>Loading - 241163577</p>
                                    </div>
                                    <div className='rcf_details'><Link><FontAwesomeIcon icon={faEye} /></Link></div>
                                </div>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div>
                                        <p>Scheduled - <b>26 Nov 15:00 <span></span></b> CEST</p>
                                        <p>Actual - <b>26 Nov 15:00 <span></span></b> CEST</p>
                                    </div>
                                    <div className='rfp'><span><FontAwesomeIcon icon={faCircleCheck} /> RFP</span></div>
                                </div>
                            </div>

                            <div className='onging_vehicle mb-2'>
                                <div className='rcf_location'><FontAwesomeIcon icon={faLocationDot} /></div>
                                <div className='d-flex justify-content-between borderh align-items-center'>
                                    <div>
                                        <h3>WFS - AMS</h3>
                                        <p>Loading - 241163577</p>
                                    </div>
                                    <div className='rcf_details'><Link><FontAwesomeIcon icon={faEye} /></Link></div>
                                </div>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div>
                                        <p>Scheduled - <b>26 Nov 15:00 <span></span></b> CEST</p>
                                        <p>Actual - <b>26 Nov 15:00 <span></span></b> CEST</p>
                                    </div>
                                    <div className='rcf'><span><FontAwesomeIcon icon={faSpinner} /> RCF</span></div>
                                </div>
                            </div>

                            <div className='onging_vehicle mb-2'>
                                <div className='rcf_location'><FontAwesomeIcon icon={faLocationDot} /></div>
                                <div className='d-flex justify-content-between borderh align-items-center'>
                                    <div>
                                        <h3>Challenge Handling - LGG</h3>
                                        <p>Loading - 241163577</p>
                                    </div>
                                    <div className='rcf_details'><Link><FontAwesomeIcon icon={faEye} /></Link></div>
                                </div>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div>
                                        <p>Scheduled - <b>26 Nov 15:00 <span></span></b> CEST</p>
                                        <p>Actual - </p>
                                    </div>
                                    <div className='rfp'><span><FontAwesomeIcon icon={faCircleCheck} /> RFP</span></div>
                                </div>
                            </div>

                            <div className='onging_vehicle'>
                                <div className='rcf_location'><FontAwesomeIcon icon={faLocationDot} /></div>
                                <div className='d-flex justify-content-between borderh align-items-center'>
                                    <div>
                                        <h3>WFS - LGG</h3>
                                        <p>Loading - 241163577</p>
                                    </div>
                                    <div className='rcf_details'><Link><FontAwesomeIcon icon={faEye} /></Link></div>
                                </div>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div>
                                        <p>Scheduled - <b>26 Nov 15:00 <span></span></b> CEST</p>
                                        <p>Actual - </p>
                                    </div>
                                    <div className='rcf'><span><FontAwesomeIcon icon={faSpinner} /> RCF</span></div>
                                </div>
                            </div>
                        </div>
                        <div className='movment_history'>
                            <h3>Movement History</h3> <Link to='#' onClick={movementHistoryClick}>View All</Link>
                        </div>
                        <div className='movment_list'>
                            <ul>
                                {/* {selectedRowData && selectedRowData.movement_history.slice(0, 5).map((history, index) => ( */}
                                <li>
                                    <span className='movem'>sada</span>
                                    <span className='mvdate'>asdsad</span>
                                    <Link to='#' >Details</Link> {/* onClick={() => handleDetailsClick(history)} */}
                                </li>
                                {/* ))} */}
                            </ul>
                        </div>
                        <ImageUpload
                            ref={imageUploadRef}
                            attachable_type={"rfs_vehicle"}
                            attachable_id={selectedRowData.order_id}
                            attachments={selectedRowData.attachments}
                        // onDeleteSuccess={() => loadDetails(selectedRowData.order_id)}
                        />
                        <ActivityComments
                            commentable_type={"rfs_vehicle"}
                            commentable_id={selectedRowData.order_id}
                            allactivities={selectedRowData.activities}
                        // onReloadDetails={() => loadDetails(selectedRowData.order_id)}
                        />
                    </div>
                )}
            </div>
            {/* <TripEditModal rowData={rowData} onSuccess={ refreshGrid } mode={mode} setMode={setMode}></TripEditModal> */}
            <TripEditModal rowData={rowData} setRowData={setRowData} onSuccess={refreshGrid} mode={mode} setMode={setMode}></TripEditModal>
            {/* <Modal show={showModalRequestSlot} onHide={() => setShowModalRequestSlot(false)} className='addfrom change_type truck_monitor_modal' centered size={'xl'} scrollable={true}>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <div className="stepper-wrapper">
                        <div className="stepper-left">
                            <h4 className="stepper-title">CREATE TRIP</h4>
                            <div className="stepper-menu">
                                {steps.map((step, index) => {
                                    const isActive = step.id === activeStep;
                                    const isCompleted = step.id < activeStep;
                                    return (
                                        <div key={step.id} className={`stepper-item ${isActive ? "active" : ""}`} onClick={() => handleStepClick(step.id)}>
                                            <div className={`step-number ${isCompleted ? "completed" : isActive ? "active-number" : ""}`}>
                                                {isCompleted ? "✓" : step.id}
                                            </div>
                                            <div className="step-text">{step.title}</div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className="stepper-content">
                            <h2>{steps.find((s) => s.id === activeStep)?.title}</h2>
                            <div className="step-content-box">
                                {activeStep === 1 &&
                                    <div>
                                        <Row>
                                            <Col md={6}>
                                                <div className='driver_truck_details'>
                                                    <Form.Group className="mb-2">
                                                        <Form.Label>Driver / Truck Details</Form.Label>
                                                        <div className='d-flex'>
                                                            <Form.Check
                                                                type="radio"
                                                                id="vehicle-truck"
                                                                label="Export"
                                                                name="trip_status"
                                                                value="Export"
                                                                checked={tdFormData.trip_status === "Export"}
                                                                onChange={() =>
                                                                    handleChange("td", { target: { name: "trip_status", value: "Export" } })
                                                                }
                                                            />

                                                            <Form.Check
                                                                type="radio"
                                                                id="vehicle-van"
                                                                label="Import"
                                                                name="trip_status"
                                                                value="Import"
                                                                checked={tdFormData.trip_status === "Import"}
                                                                onChange={() =>
                                                                    handleChange("td", { target: { name: "trip_status", value: "Import" } })
                                                                }
                                                            />
                                                        </div>
                                                    </Form.Group>
                                                    <Form.Group className="mb-2">
                                                        <div className="d-flex">
                                                            <Form.Check
                                                                type="radio"
                                                                id="side-loading-yes"
                                                                label="Intact"
                                                                name="side_loading"
                                                                value="Intact"
                                                                checked={tdFormData.side_loading === "Intact"}
                                                                onChange={() =>
                                                                    handleChange("td", { target: { name: "side_loading", value: "Intact" } })
                                                                }
                                                            />

                                                            <Form.Check
                                                                type="radio"
                                                                id="side-loading-no"
                                                                label="Loose"
                                                                name="side_loading"
                                                                value="Loose"
                                                                checked={tdFormData.side_loading === "Loose"}
                                                                onChange={() =>
                                                                    handleChange("td", { target: { name: "side_loading", value: "Loose" } })
                                                                }
                                                            />
                                                        </div>
                                                    </Form.Group>
                                                    <Form.Group className="mb-2">
                                                        <Form.Label>Truck License Plate</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="truck_license_plate"
                                                            value={tdFormData.truck_license_plate}
                                                            onChange={(e) => handleChange("td", e)}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group className="mb-2">
                                                        <Form.Label>Trailer License Plate</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="trailer_license_plate"
                                                            value={tdFormData.trailer_license_plate}
                                                            onChange={(e) => handleChange("td", e)}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group className="mb-2">
                                                        <Form.Label>Driver 1 First Name</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="driver1_first_name"
                                                            value={tdFormData.driver1_first_name}
                                                            onChange={(e) => handleChange("td", e)}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group className="mb-2">
                                                        <Form.Label>Driver 1 Last Name</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="driver1_last_name"
                                                            value={tdFormData.driver1_last_name}
                                                            onChange={(e) => handleChange("td", e)}
                                                        />
                                                    </Form.Group>
                                                    <Link to="#" className="w-100 d-inline-block text-end pe-2 add_driver"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setDriver2(prev => {
                                                                const next = !prev;
                                                                if (!next) {
                                                                    setTdFormData(prevData => ({
                                                                        ...prevData,
                                                                        driver2_first_name: '',
                                                                        driver2_last_name: ''
                                                                    }));
                                                                }
                                                                return next;
                                                            });
                                                        }}
                                                    >
                                                        {driver2 ? 'Remove Driver 2' : 'Add Driver 2'}
                                                    </Link>
                                                    {driver2 &&
                                                        <>
                                                            <Form.Group className="mb-2">
                                                                <Form.Label>Driver 2 First Name</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="driver2_first_name"
                                                                    value={tdFormData.driver2_first_name}
                                                                    onChange={(e) => handleChange("td", e)}
                                                                />
                                                            </Form.Group>
                                                            <Form.Group className="mb-2">
                                                                <Form.Label>Driver 2 Last Name</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="driver2_last_name"
                                                                    value={tdFormData.driver2_last_name}
                                                                    onChange={(e) => handleChange("td", e)}
                                                                />
                                                            </Form.Group>
                                                        </>
                                                    }
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className='oder_details driver_truck_details'>
                                                    <div className='d-flex justify-content-between align-items-center'>
                                                        <h6>Order Details</h6>
                                                        <Button onClick={() => setOrderDetailsModal(true)}>Add</Button>
                                                    </div>
                                                    {gridSelectData.map((order, index) => (
                                                        <div className="order_details_list" key={order.id ?? index}>
                                                            <div className="oder_no">
                                                                <h6>Order No.</h6>
                                                                <p>{order.order_no ?? '-'}</p>
                                                            </div>
                                                            <div className="truck_no">
                                                                <h6>Truck No.</h6>
                                                                <p>{order.truck_no ?? '-'}</p>
                                                            </div>
                                                            <div className="truck_no">
                                                                <h6>Truck Date</h6>
                                                                <p>{order.truck_date
                                                                    ? new Date(order.truck_date).toISOString().split('T')[0]
                                                                    : ''
                                                                }</p>
                                                            </div>
                                                            <div className="dlt_icon"
                                                                onClick={() =>
                                                                    setGridSelectData(prev =>
                                                                        prev.filter((_, i) => i !== index)
                                                                    )
                                                                }
                                                            >
                                                                <img src={bin} alt="bin" />
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                }
                                {activeStep === 2 &&
                                    <div>
                                        <Row>
                                            <Col sm="6" className='pe-0'>
                                                <div className="loading_dv">
                                                    <h2>Loading Station</h2>
                                                    <StationLoop type="loading" data={sbFormData.loading} setSbFormData={setSbFormData} />
                                                </div>
                                            </Col>
                                            <Col sm="6">
                                                <div className="unloading_dv">
                                                    <h2>Unloading Station</h2>
                                                    <StationLoop type="unloading" data={sbFormData.unloading} setSbFormData={setSbFormData} />
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                }
                            </div>
                            <div className="stepper-buttons are_bottom ">
                                <button className="btn-prev" disabled={activeStep === 1} onClick={goPrevious}>
                                    Previous
                                </button>
                                <button className="btn-next" onClick={activeStep === 2 ? handleSubmit : goNext}>
                                    {activeStep === 2 ? "Finalize" : "Next"}
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer></Modal.Footer>
            </Modal>
            <Modal show={orderDetailsModal} onEntered={loadGrid} onHide={() => setOrderDetailsModal(false)} className='addfrom change_type truck_monitor_modal' centered size={'xl'} scrollable={true}>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h3>Add Truck Order</h3>
                    <p>Please select any order in this list</p>
                    <Row>
                        <Col md={6}>
                            {!isLoadingod && (
                                <div ref={gridRefs} className="staion_grid" />
                            )}
                        </Col>
                        <Col md={6}>
                            <div className="oder_details driver_truck_details selected_order_list">
                                <h3>Selected Orders</h3>
                                {gridSelectData.map((order, index) => (
                                    <div className="order_details_list" key={order.id ?? index}>
                                        <div className="oder_no">
                                            <h6>Order No.</h6>
                                            <p>{order.order_no ?? '-'}</p>
                                        </div>
                                        <div className="truck_no">
                                            <h6>Truck No.</h6>
                                            <p>{order.truck_no ?? '-'}</p>
                                        </div>
                                        <div className="truck_no">
                                            <h6>Truck Date</h6>
                                            <p>{order.truck_date
                                                ? new Date(order.truck_date).toISOString().split('T')[0]
                                                : ''
                                            }</p>
                                        </div>

                                        <div className="dlt_icon"
                                            onClick={() => uncheckGridRowById(order.id)}
                                        // onClick={() =>
                                        //     setGridSelectData(prev =>
                                        //         prev.filter((_, i) => i !== index)
                                        //     )
                                        //     const rows = window.$(gridRefs.current).jqxGrid('getrows');
                                        //     const rowIndex = rows.findIndex(r => r.id === order.id);

                                        //     if (rowIndex !== -1) {
                                        //         window.$(gridRefs.current).jqxGrid('unselectrow', rowIndex);
                                        //     }
                                        // }

                                        >
                                            <img src={bin} alt="bin" />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex w-25 are_bottom">
                        <Button variant="primary" onClick={() => handleAddorder()} className='me-3'> Add Order</Button>
                    </div>
                </Modal.Footer>
            </Modal> */}
        </>
    )
}

export default VehicleView;